module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-fill-1bfbb931.svg";